export default __webpack_public_path__ + "static/media/notif_update_request.eb269f43.svg";